export const NAV_ITEMS = ["reserve"]
